module.exports = __webpack_public_path__ + "img/visitormatch-logo.d2d8a288.png";